import { withStyles } from '@material-ui/core'
import { ToggleButton } from '@material-ui/lab'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI/colors.constant'

export const AsterToggleButton = withStyles(theme => ({
  root: {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '6px !important',
    color: GRAY_COLORS[500],
    fontWeight: 600,
    fontSize: 14,
    margin: 0,
    padding: '8px 12px',
    whiteSpace: 'nowrap',

    '&.Mui-selected': {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700]
    }
  }
}))(ToggleButton)
